<template>
  <div>
    <button class="back-icon" @click="$router.push('/')">
      <BackIcon />
    </button>
    <iframe
      :src="$route.query"
      frameborder="0"
      style="width: 100%; height: 93vh;"
    ></iframe>
  </div>
</template>

<script>
import BackIcon from '../components/svgIcons/BackIcon';

export default {
  components: { BackIcon },
  name: 'NewsInDetail',
};
</script>

<style lang="scss" scoped>
.back-icon {
  padding: 1em;
  background: white;
  outline: none;
  border: none;
  // svg{
  //     position: absolute;
  //     top: 50%;
  //     left: 50%;
  //     transform: translate(-50%, -50%);
  // }
}
</style>
